import styled from 'styled-components'

export const ModalContent = styled.div`
  max-width: 500px;
  width: 100%;
  text-align: center;
`

export const SuccessIcon = styled.div`
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
`

export const SubTitleContent = styled.div`
  p{
    color: #898989
  }
`

export const Message = styled.div`
  margin-bottom: 24px;
  line-height: 1.5;
`

export const AdviceBox = styled.div`
  background-color: #FFFEB5;
  padding: 20px 24px;
  border-radius: 8px;
  margin-bottom: 24px;
  line-height: 1.5;
`

export const UnavailabilityLink = styled.span`
  color: #1F35B5;
  text-decoration: none;
  cursor: pointer;
  font-weight: bold;

  &:hover {
    color: #0d1f6b;
  }
`

export const ActionButton = styled.div`
  .CancelSuccessModal__CloseButton {
    background-color: #1F35B5;
    color: white;
    min-width: 200px;
  }
`
